"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UIServiceImpl = void 0;
const api_external_contract_js_1 = require("@tableau/api-external-contract-js");
const api_internal_contract_js_1 = require("@tableau/api-internal-contract-js");
const api_shared_js_1 = require("@tableau/api-shared-js");
const DEFAULT_DIALOG_HEIGHT = 400; // in pixels
const DEFAULT_DIALOG_WIDTH = 600; // in pixels
const DEFAULT_DIALOG_STYLE = api_external_contract_js_1.DialogStyle.Window;
class UIServiceImpl extends api_shared_js_1.ServiceImplBase {
    get serviceName() {
        return "UIService" /* ExtensionsServiceNames.UIService */;
    }
    displayDialogAsync(url, payload, isExtensionDialog, options) {
        const parameters = {
            [api_internal_contract_js_1.ParameterId.FunctionName]: 'displayDialogAsync',
            [api_internal_contract_js_1.ParameterId.ExtensionDialogUrl]: url,
            [api_internal_contract_js_1.ParameterId.ExtensionDialogPayload]: payload,
        };
        // The dialog url source refers to who is opening a new dialog (i.e. the dialog's parent).
        // If the host extension is opening a dialog we leave the source url as undefined to help us differentiate from other dialogs.
        if (isExtensionDialog) {
            parameters[api_internal_contract_js_1.ParameterId.ExtensionDialogUrlSource] = window.location.href;
        }
        const h = options && options.height ? options.height : DEFAULT_DIALOG_HEIGHT;
        const w = options && options.width ? options.width : DEFAULT_DIALOG_WIDTH;
        const dialogStyle = options && options.dialogStyle ? options.dialogStyle : DEFAULT_DIALOG_STYLE;
        // On the platform side, we do something reasonable regardess of whether the passed
        // height and width are too large or too small.  But this likely indicates a developer error,
        // so we throw an error here to help with debugging.
        if (h <= 0 || w <= 0) {
            throw new api_shared_js_1.TableauError(api_external_contract_js_1.ErrorCodes.InvalidParameter, 'Size parameters for displayDialogAsync must be positive');
        }
        parameters[api_internal_contract_js_1.ParameterId.ExtensionDialogH] = h;
        parameters[api_internal_contract_js_1.ParameterId.ExtensionDialogW] = w;
        api_shared_js_1.ErrorHelpers.verifyEnumValue(dialogStyle, api_external_contract_js_1.DialogStyle, 'DialogStyle');
        parameters[api_internal_contract_js_1.ParameterId.ExtensionDialogStyle] = api_shared_js_1.ExternalToInternalEnumMappings.dialogStyles.convert(dialogStyle);
        return this.execute(api_internal_contract_js_1.VerbId.DisplayDialog, parameters).then((response) => {
            const dialogResult = response.result;
            switch (dialogResult) {
                case api_internal_contract_js_1.ExtensionDialogResult.DialogAlreadyOpen:
                    throw new api_shared_js_1.TableauError(api_external_contract_js_1.ErrorCodes.DialogAlreadyOpen, 'There already exists an open dialog for this extension.');
                case api_internal_contract_js_1.ExtensionDialogResult.InvalidDomain:
                    throw new api_shared_js_1.TableauError(api_external_contract_js_1.ErrorCodes.InvalidDomainDialog, 'The url of an extension dialog must match the domain of the parent extension.');
                default:
                    // Success case
                    return;
            }
        });
    }
    closeDialog(payload, dialogUrl) {
        const parameters = {
            [api_internal_contract_js_1.ParameterId.FunctionName]: 'closeDialog',
            [api_internal_contract_js_1.ParameterId.ExtensionDialogUrlSource]: window.location.href,
        };
        if (payload) {
            parameters[api_internal_contract_js_1.ParameterId.ExtensionDialogPayload] = payload;
        }
        if (dialogUrl) {
            parameters[api_internal_contract_js_1.ParameterId.ExtensionDialogUrl] = dialogUrl;
        }
        return this.execute(api_internal_contract_js_1.VerbId.CloseDialog, parameters).then(() => {
            return;
        });
    }
    sendDialogMessageAsync(message, targetDialogUrl) {
        const parameters = {
            [api_internal_contract_js_1.ParameterId.FunctionName]: 'sendDialogMessage',
            [api_internal_contract_js_1.ParameterId.ExtensionDialogMessage]: message,
            [api_internal_contract_js_1.ParameterId.ExtensionDialogUrlSource]: window.location.href,
        };
        if (targetDialogUrl) {
            parameters[api_internal_contract_js_1.ParameterId.ExtensionDialogUrl] = targetDialogUrl;
        }
        return this.execute(api_internal_contract_js_1.VerbId.SendDialogMessage, parameters).then(() => {
            return;
        });
    }
    sendDialogMessageToParentAsync(message) {
        const parameters = {
            [api_internal_contract_js_1.ParameterId.FunctionName]: 'sendMessageToParent',
            [api_internal_contract_js_1.ParameterId.ExtensionDialogMessage]: message,
            [api_internal_contract_js_1.ParameterId.ExtensionDialogUrlSource]: window.location.href,
        };
        return this.execute(api_internal_contract_js_1.VerbId.SendMessageToParent, parameters).then(() => {
            return;
        });
    }
    setClickThroughAsync(clickThroughEnabled, extensionZoneId) {
        api_shared_js_1.ErrorHelpers.verifyParameterType(clickThroughEnabled, 'boolean', 'clickThroughEnabled');
        if (extensionZoneId === undefined || extensionZoneId <= 0) {
            throw new api_shared_js_1.TableauError(api_external_contract_js_1.ErrorCodes.InternalError, 'Extension Id is invalid.');
        }
        const parameters = {
            [api_internal_contract_js_1.ParameterId.ExtensionZoneId]: extensionZoneId,
            [api_internal_contract_js_1.ParameterId.ClickThroughEnabled]: clickThroughEnabled,
        };
        return this.execute(api_internal_contract_js_1.VerbId.SetClickThrough, parameters).then(() => {
            return;
        });
    }
}
exports.UIServiceImpl = UIServiceImpl;
//# sourceMappingURL=UIServiceImpl.js.map